import type { Doc } from '../../../convex/_generated/dataModel';
import type { Activity } from '../../types';

type ActivityDocWithUrls = Doc<'activities'> & { imageUrls?: string[] };

/** Map Convex `activities` document to app `Activity` (list + detail). */
export function activityFromConvexDoc(doc: ActivityDocWithUrls): Activity {
  return {
    id: String(doc._id),
    name: doc.name,
    type: doc.type,
    description: doc.description,
    price: doc.price,
    duration: doc.duration ?? '',
    capacity: doc.capacity,
    equipment: doc.equipment ?? [],
    isAvailable: doc.isAvailable,
    images: doc.imageUrls ?? [],
    pageDescription: doc.pageDescription,
    zoneInMap: doc.zoneInMap,
    openingPeriods: doc.openingPeriods ?? [],
    sales: doc.sales ?? 0,
    marketingLabels: doc.marketingLabels ?? [],
    includedServices: doc.includedServices ?? [],
    nonIncludedServices: doc.nonIncludedServices ?? [],
    optionalPaidServices: doc.optionalPaidServices ?? [],
    clientTypes: doc.clientTypes ?? [],
  };
}

export function activitiesFromConvexDocs(docs: ActivityDocWithUrls[] | undefined): Activity[] {
  if (!docs?.length) return [];
  return docs.map(activityFromConvexDoc);
}
